import React, { useEffect, useState } from 'react'
import './Navbar.css'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'

const Navbar = () => {

    const { id } = useParams()

    const location = useLocation();
    const navigate = useNavigate()

    const [isOffcanvasOpen, setOffcanvasOpen] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [windwoWidth, setWindwoWidth] = useState(window.innerWidth);

    const handleToggleOffcanvas = () => {
        setOffcanvasOpen(!isOffcanvasOpen);
    };

    const isMobile = window.matchMedia('(max-width:991px)').matches



    const handleScrollToPlay = () => {

        setOffcanvasOpen(false);
        if (location.pathname === '/') {
            const scrollToGameplay = document.getElementById('howtoplay');
            if (scrollToGameplay) {
                scrollToGameplay.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            const scrollAfterTransition = () => {
                navigate('/');
                setTimeout(() => {
                    const scrollToGamerate = document.getElementById('howtoplay');
                    if (scrollToGamerate) {
                        scrollToGamerate.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 300);
            };
            window.requestAnimationFrame(scrollAfterTransition);
        }

        handleToggleOffcanvas()
        setShowOverlay(false)

    };

    const handleScrollToGamerate = () => {

        setOffcanvasOpen(false);
        if (location.pathname === '/') {
            const scrollToGameplay = document.getElementById('gamerate');
            if (scrollToGameplay) {
                scrollToGameplay.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            navigate('/');
            setTimeout(() => {
                const scrollToGameplay = document.getElementById('gamerate');
                if (scrollToGameplay) {
                    scrollToGameplay.scrollIntoView({ behavior: 'smooth' });
                }
            }, 10); // Delay the scroll to allow time for the page transition
        }

        handleToggleOffcanvas()
        setShowOverlay(false)

    }

    useEffect(() => {

        const handleResize = () => setWindwoWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, [location])

    return (
        <>

            <div className='overlay-position'>
                <nav className='navbar navbar-expand-lg navbar-light'>
                    <div className='container'>
                        <Link className='navbar-brand' to='/'>
                            <div className='logo'>
                                <span className='shri'>Lata</span>
                                <span className='bets'>777</span>
                            </div>
                        </Link>

                        <button
                            className='navbar-toggler'
                            type='button'
                            onClick={() => {
                                handleToggleOffcanvas()
                                setShowOverlay(true)
                            }}
                        >
                            <span className='navbar-toggler-icon' />
                        </button>

                        <div
                            className={`offcanvas offcanvas-end ${isOffcanvasOpen ? 'show' : ''
                                }`}
                            tabIndex={-1}
                            id='offcanvasRight'
                            aria-labelledby='offcanvasRightLabel'
                        >


                            <div className='offcanvas-header'>
                                <button
                                    type='button'
                                    className='btn-close text-reset'
                                    onClick={() => {
                                        handleToggleOffcanvas()
                                        setShowOverlay(false)
                                    }}
                                    aria-label='Close'
                                ></button>
                            </div>

                            <div className='offcanvas-body'>
                                <ul className={`navbar-nav ms-auto ${isMobile ? 'new-style' : ''}`}>
                                    <li
                                        className={`nav-item ${location.pathname === '/' ? 'active' : ''
                                            }`}
                                    >
                                        <Link
                                            to='/'
                                            className='nav-link'
                                            aria-current='page'

                                        >
                                            HOME
                                        </Link>
                                    </li>

                                    <li className='nav-item'>
                                        <a
                                            className='nav-link'
                                            href='#howtoplay'
                                            onClick={handleScrollToPlay}
                                        >
                                            HOW TO PLAY
                                        </a>
                                    </li>

                                    <li className='nav-item'>
                                        <a
                                            className='nav-link'
                                            href='#gamerate'
                                            onClick={handleScrollToGamerate}
                                        >
                                            GAME-RATE
                                        </a>
                                    </li>

                                    <li
                                        className={`nav-item ${location.pathname === '/market-result' ||
                                            location.pathname ===
                                            `/market-result/panachart/${id}` ||
                                            location.pathname ===
                                            `/market-result/jodichart/${id}`
                                            ? 'active'
                                            : ''
                                            }`}
                                    >
                                        <Link
                                            to='/market-result'
                                            className='nav-link'

                                        >
                                            CHART
                                        </Link>
                                    </li>

                                    <li
                                        className={`nav-item ${location.pathname === '/starline' ? 'active' : ''
                                            }`}
                                    >
                                        <Link
                                            to='/starline'
                                            className='nav-link'
                                        >
                                            STARLINE
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </nav>
            </div>
            <div className={`${showOverlay ? 'overlay' : ''}`}></div>
        </>
    )
}

export default Navbar
